<div class="container-wrapper d-flex flex-wrap gap-3 justify-content-between w-100">
    <!-- Coordonnées Card -->
    <div class="global-card p-3 bg-white border rounded flex-grow-1">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h2 class="mb-0">Coordonnées</h2>
        </div>

        <!-- Spinner -->
        <div class="spinner-container" *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
            <div class="spinner-border" role="status" style="color: rgba(19, 74, 211, 1)">
                <span class="sr-only"></span>
            </div>
        </div>

        <!-- Content -->
        <div class="d-flex flex-column" *ngIf="!isLoading">
            <!-- Phone Section -->
            <div class="form-section mb-2">
                <label class="form-label">Numéros de téléphone</label>
                <div class="input-group custom-input-group mb-1" *ngFor="let phone of client.telephones; let index = index">
                    <div class="d-flex align-items-center w-100">
                        <div class="input-wrapper position-relative flex-grow-1">
                            <input
                                    type="tel"
                                    class="form-control input-with-icons"
                                    [value]="phone.code_pays + phone.num_tel"
                                    disabled
                                    style="background-color: #f9f9f9; cursor: default;"
                            />
                            <div class="input-icons">
                               <!-- <span class="icon-wrapper-blue"><span data-feather="check-square" [size]="20"></span></span>-->
                               <!-- <span class="icon-wrapper-green"><span data-feather="phone" [size]="20"></span></span> -->
                            </div>
                        </div>

                        <!-- Bouton Éditer -->
                        <button type="button" class="btn edit-button ms-2" (click)="openPhoneEditModal(index)" title="Modifier" style="margin-left: 8px">
                            <span data-feather="edit-3" class="edit-icon"></span>
                        </button>

                        <!-- Bouton Supprimer (seulement si plus d'un) -->
                        <button
                                type="button"
                                class="btn del-button ms-2"
                                *ngIf="client.telephones.length >= 1"
                                (click)="openPhoneDeleteModal(index)"
                                title="Supprimer"
                                style="margin-left: 8px;">
                            <span data-feather="trash-2" [size]="18"></span>
                        </button>
                    </div>
                </div>

                <div *ngIf="client.telephones.length < 5">
                    <a (click)="openPhoneAddModal()" style="color: rgba(19, 74, 211, 1); cursor: pointer;">
                        <b class="ajoutAdr">Ajouter un numéro de téléphone</b>
                    </a>
                </div>
            </div>

            <!-- Email Section -->
            <div class="form-section">
                <label class="form-label">Adresse e-mail</label>
                <div class="input-group custom-input-group mb-1" *ngFor="let email of client.emails; let index = index">
                    <div class="d-flex align-items-center w-100">
                        <div class="input-wrapper position-relative flex-grow-1">
                            <a
                                    [href]="'mailto:' + email.email"
                                    target="_blank"
                                    class="email-link-full"
                                    title="Envoyer un e-mail à {{ email.email }}">
                                <input
                                        type="email"
                                        class="form-control input-with-icons"
                                        [value]="email.email"
                                        disabled
                                        style="background-color: #f9f9f9; cursor: pointer;"
                                />
                                <div class="input-icons">
                                    <span class="icon-wrapper-blue-green"><span data-feather="mail" [size]="20"></span></span>
                                </div>
                            </a>
                        </div>

                        <!-- Bouton Éditer -->
                        <button type="button" class="btn edit-button ms-2" (click)="openEmailEditModal(index)" title="Modifier" style="margin-left: 8px">
                            <span data-feather="edit-3" class="edit-icon"></span>
                        </button>

                        <!-- Bouton Supprimer (visible si plus d'un email) -->
                        <button
                                type="button"
                                class="btn del-button ms-2"
                                *ngIf="client.emails.length >= 1"
                                (click)="openEmailDeleteModal(index)"
                                title="Supprimer"
                                style="margin-left: 8px;">
                            <span data-feather="trash-2" [size]="18"></span>
                        </button>
                    </div>
                </div>

                <div>
                    <a (click)="openEmailAddModal()" style="color: rgba(19, 74, 211, 1); cursor: pointer;">
                        <b class="ajoutAdr">Ajouter une adresse e-mail</b>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- Adresse Card -->
    <div class="global-card p-3 bg-white border rounded flex-grow-1">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h2 class="mb-0">Adresse</h2>
        </div>
        <!-- Spinner -->
        <div class="spinner-container" *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
            <div class="spinner-border" role="status" style="color: rgba(19, 74, 211, 1)">
                <span class="sr-only"></span>
            </div>
        </div>
        <!-- Content (shown when not loading) -->
        <div class="d-flex flex-column" *ngIf="!isLoading">
            <div class="form-section" *ngFor="let address of client.adresses; let index = index">
                <div class="d-flex align-items-center w-100">
                    <div class="input-wrapper">
                        <div class="title-container d-flex align-items-center">
                            <p class="titre1">{{ address.type === 'adresse_fac' ? 'Adresse de facturation' : 'Adresse de livraison' }}</p>
                            <button
                                    type="button"
                                    class="btn edit-button ms-2"
                                    (click)="editAddress(index)"
                                    aria-label="Modifier l'adresse"
                            >
                                <span data-feather="edit-3" class="edit-icon"></span>
                            </button>
                        </div>
                        <p class="titre2">{{ address.adresse }}</p>
                        <p class="titre2">{{ address.code_postal }}, {{ address.region }}, {{ address.pays }}</p>
                    </div>
                </div>
            </div>
            <div>
                <a (click)="openModal()" style="color: rgba(19, 74, 211, 1); cursor: pointer;">
                    <b class="ajoutAdr">Ajouter une adresse</b>
                </a>
            </div>
        </div>
    </div>
    <!-- Dettes impayés Card -->
    <div class="global-card p-3 bg-white border rounded flex-grow-1" style="max-width: 220px;">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h2 class="mb-0">Dettes impayés</h2>
        </div>
        <p style="font-size: 18px; font-weight: 600;">0.000 TND</p>
    </div>
</div>

<div class="card d-flex flex-wrap justify-content-between p-3 bg-white border rounded">
    <div class="card-header d-flex justify-content-between align-items-start w-100">
        <div class="d-flex flex-column gap-3">
            <p style="font-size: 18px; font-weight: 500; color: rgba(47, 43, 61, 0.9); margin: 0;">Emis</p>
            <p style="font-size: 18px; font-weight: 500; color: rgba(47, 43, 61, 0.9); margin-top: 10px;">500.000 TND</p>
        </div>
        <div class="d-flex flex-column align-items-center">
            <div class="badge badge-light-dark d-flex align-items-center gap-2"
                 style="background-color: transparent; border: 1px solid rgba(47, 43, 61, 0.12); border-radius: 8px; padding: 8px 12px;">
                <span class="rounded-circle bg-warning" style="width: 8px; height: 8px;"></span>
                <span style="margin-left: 6px;">Dernière vente</span>
            </div>
        </div>
        <div class="d-flex flex-column align-items-end">
            <div class="date-picker-container" #datePickerContainer>
                <div ngbDropdown class="btn-group" #dateLabel (click)="openFlatpickr()">
                    <button
                            type="button"
                            class="btn"
                            style="font-size: 13px;padding: 10px 14px"
                            rippleEffect
                    >
                        Semaine
                    </button>
                    <button
                            ngbDropdownToggle
                            type="button"
                            style="padding: 10px 14px"
                            class="btn dropdown-toggle-split custom-split-toggle"
                            rippleEffect
                    >
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                </div>
                <ng2-flatpickr
                    #flatpickr
                    [config]="DateRangeOptions"
                    name="DateRange"
                    (change)="onDateChange($event)"
                    (ready)="onFlatpickrReady($event)"
                    style="position: absolute; left: -9999px;"
                ></ng2-flatpickr>
            </div>
        </div>
    </div>
    <div class="card-body w-100">
        <div id="chartjs-bar-chart">
            <canvas
                    baseChart
                    [data]="barChart.data"
                    [options]="barChart.options"
                    [type]="barChart.type"
            ></canvas>
        </div>
    </div>
</div>

<!-- Modal ajouter une adresse et edit adresse -->
<ng-template #addressModal>
    <div class="modal-header" style="background-color: transparent;">
        <button type="button" class="close" (click)="dismissModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body justify-content-center align-items-center m-0">
        <p class="modal-title titre" style="text-align: center;">{{ isEditMode ? 'Modifier une adresse' : 'Ajouter une adresse' }}</p>
        <p class="titre2" style="text-align: center; margin-top: 12px;">
            Remplissez les informations nécessaires pour {{ isEditMode ? 'modifier' : 'enregistrer' }} l’adresse.
        </p>

        <form #addressForm="ngForm" (ngSubmit)="saveAddress()">
            <!-- === LES DEUX CARTES - CLIC PARTOUT SÉLECTIONNE === -->
            <div class="align-items-start address-row" style="margin-right: 25px; margin-top: 20px;">
                <!-- Carte Facturation -->
                <div class="col-md-5 col-11 p-0">
                    <!-- On enveloppe tout dans un div cliquable -->
                    <div class="option-card2"
                         [ngClass]="{'selected': addr.type === 'adresse_fac'}"
                         (click)="addr.type = 'adresse_fac'; validateStep3()"
                         style="cursor: pointer;">

                        <div class="radio-icon-container">
                            <input
                                    type="radio"
                                    id="adresse_fac"
                                    name="addressType"
                                    value="adresse_fac"
                                    [(ngModel)]="addr.type"
                                    (change)="validateStep3()"
                                    class="form-check-input"
                                    style="pointer-events: none;"
                            />
                            <i data-feather="map-pin" [size]="15"></i>
                            <label for="adresse_fac"
                                   style="font-size: 15px; font-weight: 600; color: rgba(47, 43, 61, 0.9); margin-left: 10px; cursor: pointer;">
                                Adresse de facturation
                            </label>
                        </div>
                        <p style="font-size: 13px; font-weight: 400; margin-left: 40px; text-align: left; margin-top: 6px;">
                            Adresse où les factures seront envoyées
                        </p>
                    </div>
                </div>

                <!-- Carte Livraison -->
                <div class="col-md-5 col-12 p-0">
                    <div class="option-card2"
                         [ngClass]="{'selected': addr.type === 'adresse_li'}"
                         (click)="addr.type = 'adresse_li'; validateStep3()"
                         style="cursor: pointer;">

                        <div class="radio-icon-container">
                            <input
                                    type="radio"
                                    id="adresse_li"
                                    name="addressType"
                                    value="adresse_li"
                                    [(ngModel)]="addr.type"
                                    (change)="validateStep3()"
                                    class="form-check-input"
                                    style="pointer-events: none;"
                            />
                            <i data-feather="truck" [size]="15"></i>
                            <label for="adresse_li"
                                   style="font-size: 15px; font-weight: 600; color: rgba(47, 43, 61, 0.9); margin-left: 10px; cursor: pointer;">
                                Adresse de livraison
                            </label>
                        </div>
                        <p style="font-size: 13px; font-weight: 400; margin-left: 40px; text-align: left; margin-top: 6px;">
                            Adresse où les commandes seront livrées
                        </p>
                    </div>
                </div>
            </div>

            <!-- === CHAMPS RESTANTS (identiques à ton code) === -->
            <div class="row g-3" style="width: 100%; margin-left: 2px; margin-top: 10px;">
                <div class="col-md-4 p-0">
                    <label class="form-label">Pays</label>
                    <select class="form-control" [(ngModel)]="addr.pays" name="pays" required (ngModelChange)="validateStep3()">
                        <option value="">Sélectionner un pays</option>
                        <option value="FR">France</option>
                        <option value="BE">Belgique</option>
                        <option value="CH">Suisse</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Région</label>
                    <select class="form-control" [(ngModel)]="addr.region" name="region" required (ngModelChange)="validateStep3()">
                        <option value="">Sélectionner une région</option>
                        <option value="Île-de-France">Île-de-France</option>
                        <option value="Provence-Alpes-Côte d'Azur">Provence-Alpes-Côte d'Azur</option>
                        <option value="Wallonie">Wallonie</option>
                    </select>
                </div>
                <div class="col-md-4 p-0">
                    <label class="form-label">Code postal</label>
                    <input type="text" class="form-control" placeholder="Entrez le code postal"
                           [(ngModel)]="addr.code_postal" name="code_postal" required (ngModelChange)="validateStep3()" />
                </div>
            </div>

            <div class="col-12 p-0" style="margin-top: 10px;">
                <label class="form-label">Adresse</label>
                <input type="text" class="form-control" placeholder="Entrez Adresse"
                       [(ngModel)]="addr.adresse" name="adresse" required (ngModelChange)="validateStep3()" />
            </div>

            <div class="d-flex gap-2 align-items-center justify-content-center" style="margin-top: 12px;">
                <button type="submit" [disabled]="!addressForm.valid" class="btn button" style="margin-right: 24px;">
                    Confirmer
                </button>
                <button type="button" class="btn button-second" (click)="dismissModal()">Annuler</button>
            </div>
        </form>
    </div>
</ng-template>
<!-- Delete Phone Modal -->
<ng-template #deletePhoneModal>
    <div class="modal-header" style="background-color: transparent;">
        <button type="button" class="close" (click)="closePhoneModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body justify-content-center align-items-center" >
        <p class="modal-title titrePop" style="text-align: center;">
            {{ isPhoneAddMode ? 'Ajouter un numéro de téléphone' :
            isPhoneEditMode ? 'Modifier un numéro de téléphone' :
                'Supprimer un numéro de téléphone' }}
        </p>
        <p class="titre2" style="text-align: center; margin: 8px 0 24px 0">
            {{ (isPhoneAddMode || isPhoneEditMode)
            ? 'Entrez le numéro complet (ex: +21612345678)'
            : 'Voulez-vous vraiment supprimer ce numéro ?' }}
        </p>

        <form #phoneForm="ngForm" *ngIf="isPhoneAddMode || isPhoneEditMode">
            <div class="row g-3" style="margin-top: 24px;">
                <div class="col-md-5">
                    <label class="form-label">Type</label>
                    <select class="form-control" [(ngModel)]="phoneToEdit.type" name="phoneType" required>
                        <option value="mobile">Mobile</option>
                        <option value="fixe">Fixe</option>
                        <option value="fax">Fax</option>
                        <option value="whatsapp">WhatsApp</option>
                        <option value="viber">Viber</option>
                        <option value="support">Support</option>
                    </select>
                </div>
                <div class="col-md-7">
                    <label class="form-label">Numéro de téléphone</label>
                    <input type="tel" class="form-control"
                           [(ngModel)]="phoneToEdit.num_tel_full"
                           name="phoneNum"
                           placeholder="Ex: +21612345678"
                           pattern="\+[0-9]{1,3}[0-9]{8,}"
                           required />
                </div>
            </div>

            <div class="d-flex gap-2 justify-content-center mt-4">
                <button type="button" class="btn button"
                        [disabled]="!phoneForm.valid"
                        (click)="confirmPhoneAction()">
                    Confirmer
                </button>
                <button type="button" class="btn button-second" (click)="closePhoneModal()">
                    Annuler
                </button>
            </div>
        </form>

        <!-- Boutons pour suppression -->
        <div class="d-flex gap-2 justify-content-center mt-4" *ngIf="!isPhoneAddMode && !isPhoneEditMode">
            <button type="button" class="btn button" (click)="confirmPhoneAction()">
                Supprimer
            </button>
            <button type="button" class="btn button-second" (click)="closePhoneModal()">
                Annuler
            </button>
        </div>
    </div>
</ng-template>
<!-- Delete Email Modal -->
<ng-template #deleteEmailModal>
    <div class="modal-header" style="background-color: transparent;">
        <button type="button" class="close" (click)="closeEmailModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body justify-content-center align-items-center" >
        <p class="modal-title titrePop" style="text-align: center;">
            {{ isEmailAddMode ? 'Ajouter une adresse e-mail' :
            isEmailEditMode ? 'Modifier une adresse e-mail' :
                'Supprimer une adresse e-mail' }}
        </p>
        <p class="titre2" style="text-align: center; margin: 8px 0 24px 0">
            {{ (isEmailAddMode || isEmailEditMode)
            ? 'Entrez une adresse e-mail valide.'
            : 'Voulez-vous vraiment supprimer cette adresse e-mail ?' }}
        </p>

        <form #emailForm="ngForm" *ngIf="isEmailAddMode || isEmailEditMode">
            <div class="row g-3">
                <div class="col-12">
                    <label class="form-label">Adresse e-mail</label>
                    <input type="email" class="form-control"
                           [(ngModel)]="emailToEdit.email"
                           name="email"
                           placeholder="ex: contact@exemple.com"
                           pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                           required />
                </div>
            </div>

            <div class="d-flex gap-2 justify-content-center mt-4">
                <button type="button" class="btn button"
                        [disabled]="!emailForm.valid"
                        (click)="confirmEmailAction()">
                    Confirmer
                </button>
                <button type="button" class="btn button-second" (click)="closeEmailModal()">
                    Annuler
                </button>
            </div>
        </form>

        <!-- Boutons pour suppression -->
        <div class="d-flex gap-2 justify-content-center mt-4" *ngIf="!isEmailAddMode && !isEmailEditMode">
            <button type="button" class="btn button" (click)="confirmEmailAction()" style="margin-right: 16px">
                Supprimer
            </button>
            <button type="button" class="btn button-second" (click)="closeEmailModal()">
                Annuler
            </button>
        </div>
    </div>
</ng-template>
